/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

import type * as Types from '@sg/graphql-schema';

import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type OrderProductConfirmDeliveryAddressQueryVariables = Types.Exact<{
  addressId: Types.Scalars['ID']['input'];
}>;

export type OrderProductConfirmDeliveryAddressQuery = {
  readonly __typename?: 'Query';
  readonly address: {
    readonly __typename: 'Address';
    readonly id: string;
    readonly street: string;
    readonly secondaryStreet: string | null;
    readonly city: string;
    readonly state: string;
    readonly country: string;
    readonly zipCode: string;
    readonly deliveryPreference: Types.DeliveryPreferenceType;
    readonly googlePlaceId: string;
    readonly latitude: number;
    readonly longitude: number;
    readonly name: string | null;
    readonly notes: string | null;
  } | null;
};

export const OrderProductConfirmDeliveryAddressDocument = gql`
  query OrderProductConfirmDeliveryAddress($addressId: ID!) {
    address(addressId: $addressId) {
      id
      __typename
      street
      secondaryStreet
      city
      state
      country
      zipCode
      deliveryPreference
      googlePlaceId
      latitude
      longitude
      name
      notes
    }
  }
`;

export function useOrderProductConfirmDeliveryAddressQuery(
  options: Omit<
    Urql.UseQueryArgs<OrderProductConfirmDeliveryAddressQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    OrderProductConfirmDeliveryAddressQuery,
    OrderProductConfirmDeliveryAddressQueryVariables
  >({ query: OrderProductConfirmDeliveryAddressDocument, ...options });
}
